import { cn } from '@/lib/utils';

/** Shared create/edit job position dialog shell — mobile scroll + AI toggle. */
export function jobPositionDialogContentClass(options: {
  aiChatOpen: boolean;
  wizardCreated?: boolean;
}) {
  return cn(
    'flex flex-col gap-0 overflow-hidden p-0 transition-all duration-300 rounded-xl',
    '[&>button.absolute.right-4.top-4]:hidden',
    options.wizardCreated
      ? 'max-h-[90dvh] w-[calc(100vw-1rem)] max-w-[min(95vw,40rem)] sm:max-w-2xl'
      : options.aiChatOpen
        ? 'h-[90dvh] max-h-[90dvh] w-[calc(100vw-1rem)] max-w-[95vw] sm:max-h-[90vh] sm:h-auto sm:max-w-5xl'
        : 'h-[90dvh] max-h-[90dvh] w-[calc(100vw-1rem)] max-w-[95vw] sm:max-h-[90vh] sm:h-auto sm:max-w-2xl',
  );
}

export const jobPositionDialogBodyClass =
  'flex flex-col flex-1 min-h-0 md:flex-row md:h-[85vh] md:max-h-[85vh]';

export function jobPositionFormColumnClass(aiChatOpen: boolean) {
  return cn(
    'flex flex-col flex-1 min-h-0 overflow-hidden',
    aiChatOpen ? 'hidden md:flex md:w-[58%]' : 'flex w-full',
  );
}

export const jobPositionFormScrollClass =
  'flex-1 min-h-0 overflow-y-auto overscroll-contain px-6 py-4';

export const jobPositionAiColumnClass =
  'flex flex-col flex-1 min-h-0 w-full md:w-[42%] md:border-l border-border/40 bg-muted/10';
